import Vue from "vue";
export const BUSINESS_STATUS_ENUM = {
  BUS_STATUS_INTENTION_ADD: 10,
  BUS_STATUS_INTENTION_AUDIT: 11,
  BUS_STATUS_INTENTION_ASSIGN: 12,
  BUS_STATUS_PENDING_SNOW: 14,
  BUS_STATUS_PLEDGE_ADD: 20,
  BUS_STATUS_PLEDGE_STORAGE: 21,
  BUS_STATUS_PLEDGE_ADD_PRICE: 22,
  BUS_STATUS_BILL_FINAL_CONFIRM: 30,
  BUS_STATUS_BILL_FILE_UPLOAD: 31,
  BUS_STATUS_BILL_FILE_AUDIT: 32,
  BUS_STATUS_BILL_CREATE: 33,
  BUS_STATUS_BILL_FINISH: 34,
  BUS_STATUS_DELAY: 35,
  BUS_STATUS_FINISH: 36,
  BUS_STATUS_OUT_PRICE_CONFIRM: 40,
  BUS_STATUS_OUT_GOODS_AUDIT: 41,
  BUS_STATUS_OUT_BILL_CREATE: 42,
  BUS_STATUS_OUT_BILL_FINISH: 43,
  BUS_STATUS_OUT_BOUND_GOODS_AUDIT: 44,
  BUS_STATUS_OUT_BUCKLE_INVENTORY: 45,
  BUS_STATUS_OUT_FINISH: 46,
  BUS_STATUS_OUT_PENDING: 48,
  BUS_STATUS_SIGN_APPLY: 50,
  BUS_STATUS_BUSINESS_END: 110
};

export const BUSINESS_STATUS = {
  10: "意向填写",
  11: "尽调审核",
  12: "尽调指派",
  14: "等待小雪录入客户",
  20: "货物录入",
  21: "价值评估（货物审核)",
  22: "货物价格录入", // 第三方录入
  30: "最终信息确认",
  31: "质押合同上传",
  32: "质押合同审核",
  33: "待放款",
  34: "已放款",
  35: "逾期",
  36: "订单完成",
  40: "价格确认",
  41: "货物解押审核",
  42: "收款凭证确认",
  43: "出库凭证上传",
  44: "出库凭证审核",
  45: "扣库存",
  46: "解押完成",
  48: "等待出库",
  [BUSINESS_STATUS_ENUM.BUS_STATUS_BUSINESS_END]: "整笔订单结束"
};

export const DAICAI_STATUS_ENUM = {
  APPLY_FISH_ITEM: 10, //"申请渔货明细待填写"),//
  FISH_ITEM_AUDIT: 20, //"渔货明细待审核"),//
  FISH_ITEM_AUDIT_FAIL: 22, //"渔货明细审核失败"),//
  TO_CONFIRM_INFO: 30, //"最终信息待确认"),//
  TO_UPLOAD_CONTRACT: 40, //"合同待上传"),//
  TO_UPLOAD_CONTRACT_FAIL: 42, //"自营合同失败"),//
  TO_CONTRACT_AUDIT: 50, //"资料合同待审核"),//
  TO_LEND_MONEY: 60, //"待放款"),//
  TO_APPOINT: 70, //待预约
  HZ_RECEIVE_NOTIFY_FAIL: 73, //德创入库失败
  BILL_UPLOAD_AGAIN: 74, //仓单重传
  TO_UPLOAD_WAREHOUSE_RESOURCE: 80, //仓单待上传
  TO_CONFIRM_STORAGE_INFO: 90, //入库信息待确认
  DC_END: 100 //"自营入库结束");
};

export const DAICAI_STATUS = {
  10: "申请渔货明细待填写", //
  20: "渔货明细待审核", //
  22: "渔货明细审核失败", //
  30: "最终信息待确认", //
  40: "合同待上传", //
  42: "自营合同失败", //
  50: "资料合同待审核", //
  60: "待放款", //
  70: "待预约",
  73: "入库失败",
  74: "仓单重传",
  80: "仓单待上传",
  90: "入库信息待确认",
  100: "自营入库结束",
  110: "自营入库结束"
};

/** 默认利率 */
export const defaultInterestRate = 0.011;

export const quantity = (() => {
  const q = Vue.ls.get("quantity");
  if (q) return q;
  return {
    "1": "箱",
    "2": "件",
    "3": "包",
    "4": "框"
  };
})();

export const weight = {
  "1": "吨",
  "2": "斤"
};

export const WarehouseTypeMap = {
  0: "自有仓库",
  1: "小雪仓库",
  2: "杭州仓库"
};

export const warehouseTypeArr = [
  { type: 0, name: "自有仓库" },
  { type: 1, name: "小雪仓库" },
  { type: 2, name: "杭州仓库" }
];
